/**
 * Accordion behavior for Postmanager block
 * - closes others when one is opened
 * - smooth height animation via CSS
 */

document.addEventListener('DOMContentLoaded', () => {
	const accordions = document.querySelectorAll('[data-accordion]');
	if (!accordions.length) return;

	accordions.forEach((acc) => {
		const buttons = acc.querySelectorAll('.postmanager-toggle');

		buttons.forEach((btn) => {
			btn.addEventListener('click', () => {
				const panel = btn.nextElementSibling;
				const isOpen = btn.classList.contains('is-open');

				// Alle schließen
				buttons.forEach((b) => {
					b.classList.remove('is-open');
					const p = b.nextElementSibling;
					p.style.maxHeight = null;
				});

				// Aktuelles öffnen
				if (!isOpen) {
					btn.classList.add('is-open');
					panel.style.maxHeight = panel.scrollHeight + 24 + 'px';
				}
			});
		});
	});
});